import queryString from 'query-string';

export default function makeSrc({ fqdn, path, queryParams = '{}' }) {
  return `https://${fqdn}${path}?${queryString.stringify(JSON.parse(queryParams))}`;
}
